import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import styles from './common.module.scss';

import { FieldNumber, FieldText } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  const mode = useMemo(() => {
    switch (command.data.mode) {
      case 0:
        return 'Neutral';
      case 1:
        return 'Climb';
      case 2:
        return 'Descend';
      default:
        break;
    }
  }, [command.data.mode]);

  return (
    <div className={cx('container')}>
      <label>
        Relative Altitude
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.altitude.toFixed(1)} readOnly />
          <span className={cx('unit')}>m</span>
        </div>
      </label>
      <label>
        Mode
        <div className={cx('fieldWrapper')}>
          <FieldText value={mode} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
    </div>
  );
};

export default Item;
